/* Size style module */

const stdPaddingTop = 10;
const stdPaddingLeft = 10;

const size = {
  narrowWidth: 1000,
  baseWidth: 200, // == thumbnail's width (with lateral margins)
  baseMargin: 5, // == thumbnail's lateral margin
  sideBuffer: 50, // == gap between app's contents and window's edge
  stdPaddingTop,
  stdPaddingLeft,
  stdPadding: `${stdPaddingTop}px ${stdPaddingLeft}px`, // TODO make padding consistent
  controlHeight: 40, // note, icon-settings height
  controlsGap: 6,
  inputLabelPaddingTop: 7,
};

export default size;
